export const initState = {
    stormCoverEvent: [],
    stormCoverStatus: 0,
    stormCoverActivated: false,
};
const prefix = 'storm';
export const STORM_ACTION = {
    SET_STORM_INFO: `${prefix}/setStormInfo`,
    CLEAR: `${prefix}/clear`,
};
export default {
    namespaced: true,
    state: initState,
    mutations: {
        setStormInfo(state, payload) {
            state.stormCoverEvent = payload.stormCoverEvent;
            state.stormCoverStatus = payload.stormCoverStatus;
            state.stormCoverActivated = payload.stormCoverActivated;
        },
        clear(state) {
            state.stormCoverEvent = [];
            state.stormCoverStatus = 0;
            state.stormCoverActivated = false;
        },
    },
    actions: {
        setStormInfo({ commit }, payload) {
            commit('setStormInfo', payload);
        },
        clear({ commit }) {
            commit('clear');
        },
    },
};
